import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useClipboard,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { securedAxiosInstance } from '../../api/axios';

const ShareModal = ({ isOpen, onOpen, onClose, journalId }) => {
  const [sharableLink, setSharableLink] = useState('');
  const { hasCopied, onCopy } = useClipboard(sharableLink);
  useEffect(() => {
    const getSharedLink = async () => {
      const res = await securedAxiosInstance.get(
        `/journals/${journalId}/share`
      );
      setSharableLink(
        `${process.env.REACT_APP_URL}/shared_journal/${res.data.public_reference}`
      );
      return;
    };

    getSharedLink();
  }, [journalId]);

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Share journal entry</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          Users who have this link can access this journal entry.
          <Flex my={2}>
            <Input value={sharableLink} isReadOnly />
            <Button onClick={onCopy} ml={2} disabled={sharableLink === ''}>
              {hasCopied ? 'Copied' : 'Copy'}
            </Button>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} variant="outline">
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ShareModal;
